import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=31de7765&scoped=true&"
import script from "./QuestionsList.vue?vue&type=script&lang=js&"
export * from "./QuestionsList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsList.vue?vue&type=style&index=0&id=31de7765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de7765",
  null
  
)

export default component.exports